import { render, staticRenderFns } from "./error-404-page.vue?vue&type=template&id=25ee0570&scoped=true&"
import script from "./error-404-page.vue?vue&type=script&lang=js&"
export * from "./error-404-page.vue?vue&type=script&lang=js&"
import style0 from "./error-404-page.vue?vue&type=style&index=0&id=25ee0570&scoped=true&lang=css&"
import style1 from "./error-404-page.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ee0570",
  null
  
)

export default component.exports